/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import { useState } from 'react'
import "./Navbar.css"
import images from '../../Asset/Img/img'
import { Link, NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';

const lngs = {
  tr: { nativeName: 'TR' },
  en: { nativeName: 'EN' }
 
}

function Navbar({ location }) {
  const [isCheked, setIsChecked] = useState(false)
  const [isPruductCheked, setPruductCheked] = useState(false)
  const [isTecnologyCheked, setTecnologyCheked] = useState(false)
  const [isQualityCheked, setQualityCheked] = useState(false)
  const upIconHover = <FontAwesomeIcon icon={faCaretUp} />

 
  const { t, i18n } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(i18n.resolvedLanguage);
  


  const handleLanguageChange = (lng) => {
    setSelectedLanguage(lng);
    i18n.changeLanguage(lng);
  };
  function dropClick(dropEvent) {
    setIsChecked(!isCheked)
    // document.addEventListener('click', (windowEvent) => {
    //   if (dropEvent.target.className === windowEvent.target.className) {

    //   } else {
    //     setIsChecked(false)
    //   }
    // })
    document.addEventListener('scroll', () => {
      setIsChecked(false)
    })
  }


  function navDropPruductClick() {
    setPruductCheked(!isPruductCheked)
    setTecnologyCheked(false)
    setQualityCheked(false)
  }
  function navDropTecnologyClick() {
    setTecnologyCheked(!isTecnologyCheked)
    setPruductCheked(false)
    setQualityCheked(false)
  }
  function navDropQualityClick() {
    setQualityCheked(!isQualityCheked)
    setPruductCheked(false)
    setTecnologyCheked(false)
  }


  return (

    <div className={`${!isCheked ? 'navbar-container' : 'navbar-container-active'}`}>
      <div className='navbar-content'>

        <Link to="/" className='logo-container'>
          <img src={location === "/" ? images.logoWhite : images.logo} alt="logo" />
        </Link>


        <div className={`${!isCheked ? 'nav-drop-icon-container' : 'nav-drop-icon-container-active'}`} style={location === "/" ? { color: 'white' } : { color: "#364c89" }} onClick={(dropEvent) => dropClick(dropEvent)}>

          <div className={`${!isCheked ? 'icon-item icon-up' : 'icon-up-active'}`}></div>

          <div className={`${!isCheked ? 'icon-item icon-short' : 'icon-short-active'}`}></div>

          <div className={`${!isCheked ? 'icon-item icon-down' : 'icon-down-active'}`}></div>

        </div>

        <ul className={`${!isCheked ? 'link-container' : 'link-container-active'}`} >
          <li><img src={images.logo} alt="" /></li>
          <li><NavLink to='/' style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav_home')}</NavLink></li>
          <li><NavLink to='/about' style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav_about')}</NavLink></li>
          <li className='pruducts-container' >
            <div className='product-text-header' onClick={navDropPruductClick}>
              <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }} >{t('nav_pruduct')}</a>
              <p className={`${!isPruductCheked ? 'up-arrow' : 'down-arrow'}`}><FontAwesomeIcon icon={faCaretDown} /></p>
            </div>

            <div className={`${!isPruductCheked ? 'pruducts-dropdown' : 'pruducts-dropdown-active'}`}>
              {upIconHover}
              <ul className='pruducts-links'>
                <li> <Link to='/sealing'>{t('nav_pruduct_sealing')}</Link> </li>
                <li> <Link to='/vibration'>{t('nav_pruduct_vibration')}</Link> </li>
                <li> <Link to='/drinkwater'>{t('nav_pruduct_drinkwater')}</Link> </li>
                <li> <Link to='/'>{t('nav_pruduct_fireproof')}</Link> </li>
                <li> <Link to='/special'>{t('nav_pruduct_special')}</Link></li>
              </ul>
            </div>
          </li>
          <li ><NavLink to='/packaging' style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav_packaging')}</NavLink></li>

          <li className='pruducts-container'>
            <div className='product-text-header' onClick={navDropTecnologyClick}>
              <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav_technologies')}</a>
              <p className={`${!isTecnologyCheked ? 'up-arrow up-technology' : 'down-technology'}`}><FontAwesomeIcon icon={faCaretDown} /></p>
            </div>

            <div className={`${!isTecnologyCheked ? 'pruducts-dropdown' : 'technology-dropdown-active'}`}>
              {upIconHover}
              <ul className='pruducts-links'>
                <li> <Link to='/mixingprocess'>{t('nav_technologies_mixingprocess')}</Link> </li>
                <li> <Link to='/material'>{t('nav_technologies_material')}</Link> </li>
                <li> <Link to='/'>{t('nav_technologies_automotion')}</Link> </li>
              </ul>
            </div>

          </li>
          <li className='pruducts-container'>
            <div className='product-text-header' onClick={navDropQualityClick}>
              <a className="pruduct-link" style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav_quality')}</a>
              <p className={`${!isQualityCheked ? 'up-arrow up-quality' : 'down-quality'}`}><FontAwesomeIcon icon={faCaretDown} /></p>
            </div>

            <div className={`${!isQualityCheked ? 'pruducts-dropdown' : 'quality-dropdown-active'}`}>
              {upIconHover}
              <ul className='pruducts-links'>
                <li> <Link to='/qualitycontrol'>{t('nav_quality_qualitycontrol')}</Link> </li>
                <li> <Link to='/qualitassurance'>{t('nav_quality_qualitassurance')}</Link> </li>
              </ul>
            </div>
          </li>
          <li><NavLink to='/' style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav-sustainability')}</NavLink></li>
          <li><NavLink to='/contact' style={location === "/" ? { color: "white" } : { color: "" }}>{t('nav-contact')}</NavLink></li>

          <div className='language-btn' >
            {Object.keys(lngs).map((lng) => (
              <button
                style={{ backgroundColor: selectedLanguage === lng ? "#5184d0" : "#364c89" }}
                className='tr'
                type="submit"
                key={lng}
                onClick={() => handleLanguageChange(lng)}
                disabled={selectedLanguage === lng}
              >
                {lngs[lng].nativeName}
              </button>

            ))}


          </div>

        </ul>


      </div>
    </div>

  )
}

export default Navbar
